import { ROUTES } from '../../App/routes';

export const LEGAL_ENTITIES_PATH = `/${ROUTES.LEGAL_ENTITIES}`;
export const LEGAL_ENTITIES_CREATE_PATH = `${LEGAL_ENTITIES_PATH}/create`;
export const legalEntityEditPath = (id: string) => `${LEGAL_ENTITIES_PATH}/${id}/edit`;
